module.exports = function(data) {
var __t, __p = '';
__p += '<form id="merchant-forcePassChange-form">\n    <h2>' +
((__t = ( strings.login.passReset )) == null ? '' : __t) +
'</h2>\n    <div id="login-status" class="alert alert-danger hidden" role="alert"></div>\n    <div class="form-group new-password" style="margin: 25px 0;"></div>\n    <div class="submit-btn-block">\n        <button class="btn btn-lg btn-primary change-password btn-last-step" disabled="true">' +
((__t = ( strings.login.saveNewPassword )) == null ? '' : __t) +
'</button>\n    </div>\n</form>\n<div class="help-text-login">\n    <a href="/merchant/login">' +
((__t = ( strings.cancel )) == null ? '' : __t) +
'</a>\n</div>\n';
return __p
}